import * as React from 'react';
import Box from '@mui/material/Box';
import Top from "../Top";
import Bottom from "../Bottom";

const Ads = () => {

  
  return (
    <Box sx={{ minWidth: 320 }}>
      <Top title="홍보 및 마케팅 수집·이용 동의서" />

      <Box className={'contentStart'}
        sx={{
          p: '0 15px 80px 15px',
          mt: 10,
          '& > p': {
            margin: '6px',
            fontSize: 12,
          },
          'ol': { paddingLeft: '20px' },
          'ol li': { mb: '10px', fontSize: 12 },
          'ul': { paddingLeft: '20px', mt: '5px' },
          'ul li': { fontSize: 12, mb: 0 },
          'h2': { textAlign: 'center', fontSize: 18 },
          'h3': { fontSize: 14 },
          'table': { mt: '10px', borderCollapse: 'collapse', overflow: 'scroll', minWidth: 270, whiteSpace: 'nowrap', display: 'block' },
          'th': { border: '1px solid #ccc', background: '#f1f1f1', textAlign: 'center', padding: '5px', fontSize: 12, },
          'td': { border: '1px solid #ccc', padding: '5px', fontSize: 12, whiteSpace: 'normal' },
          '.bold': { fontSize: 12, fontWeight: 700 }


        }}>

        <h2>듀얼헬스케어<br />홍보 및 마케팅 수집·이용 동의서</h2>
        <p>&nbsp;</p>


        <p className='bold'>㈜듀얼헬스케어(이하 “회사” ) 사용자(또는 회원)의 개인정보 보호를 매우 중요시하며, 『개인정보 보호법』, 『정보통신망 이용촉진 및 정보 보호에 관한 법률』 등 개인정보 보호규정 및 정보통신부가 제정한 『개인정보 보호지침』을 준수합니다.
        </p>
        <p>&nbsp;</p>

        <p>회사는 사용자께 다양한 서비스(경품제공, 이벤트 알림 및 당첨, 신규 서비스 홍보 등)을 위해 아래와 같이 개인정보를 홍보 및 마케팅 목적으로 수집 및 이용하고자 합니다.
        </p>
        <table>
          <colgroup>
            <col width='15%' />
            <col width='50%' />
            <col width='20%' />
            <col width='15%' />
          </colgroup>
          <tbody>
            <tr>
              <th>구분</th>
              <th>수집 항목 목록</th>
              <th>이용 목적</th>
              <th>수집 기간</th>
            </tr>
            <tr>
              <td>홍보 및 마케팅</td>
              <td>
                [필수] 이름, 성별, 생년월일, 휴대전화번호, 주소<br />
                <b>기업 회원일 경우</b> [필수] 이름, 소속 기업, 이메일 주소, 휴대전화번호, 생년월일, 성별 <br />
                [선택] 사번, 소속팀
              </td>
              <td>경품 제공, 이벤트 알림 및 당첨, 신규 서비스 홍보 등의 홍보 목적</td>
              <td>회원 탈퇴 시</td>
            </tr>
          </tbody>
        </table>

        <p>※ 동의를 거부하는 경우 홍보 및 마케팅과 관련된 해당 서비스 이용이 불가능하며 이외의 서비스 이용에 영향을 끼치지 않습니다.</p>





      </Box>



      <Bottom />

    </Box>

  );
}


export default Ads;